import { useState, useEffect } from "react";
import { BREAKPOINTS } from "../constants/constans";
import { DeviceType } from "../constants/enum";

const useBreakpoint = () => {
  const [deviceType, setDeviceType] = useState<DeviceType>(DeviceType.Desktop);

  const updateBreakpoint = () => {
    const width = window.innerWidth;

    if (width <= BREAKPOINTS.MOBILE) {
      setDeviceType(DeviceType.Mobile);
    } else if (width <= BREAKPOINTS.TABLET) {
      setDeviceType(DeviceType.Tablet);
    } else if (width <= BREAKPOINTS.PC) {
      setDeviceType(DeviceType.Desktop);
    } else {
      setDeviceType(DeviceType.Large);
    }
  };

  useEffect(() => {
    updateBreakpoint();

    window.addEventListener("resize", updateBreakpoint);

    return () => {
      window.removeEventListener("resize", updateBreakpoint);
    };
  }, []);

  return deviceType;
};

export default useBreakpoint;
